export const inputTextPt = () => {
  return {
    root: {
      class: 'font-14-n'
    },
  }
}

export const inputTextConfig = () => {
  return {
    light: {
      shadow: 'none'
    },
    dark: {
      shadow: 'none'
    },
    root: {
      sm: {
        paddingX: '1rem',
        paddingY: '.6rem',
      }
    }
  }
}
